import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const FailedToRemoveUsers = ({ handleRemoveFileFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleRemoveFileFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleRemoveFileFailed}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.bulkImportRemoveFileFailed)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default FailedToRemoveUsers;
